import { Routes, Route } from "react-router-dom";
import Home from "../pages/main/Home";
import AboutUs from "../pages/main/Aboutus";
import Services from "../pages/main/Services";
import Contact from "../pages/main/Contact";
import ServiceDetails from "../pages/main/ServiceDetails";
import LoginModal from "../pages/auth/LoginModal";
import OtpModel from "../pages/main/Home";
import Dashboard from "../pages/booking/Dashboard";
import Address from "../pages/booking/Address";
import Quotation from "../pages/booking/Quotation";
import Mypayment from "../pages/booking/Mypayment";
import Myaddress from "../pages/booking/Myaddress";
import Myprofile from "../pages/booking/Myprofile";
import Notifications from "../pages/booking/Notifications";
import QuoteDetails from "../pages/booking/QuoteDetails";
import EditProfile from "../pages/booking/EditProfile";
import BookingDetails from "../pages/booking/BookingDetails";
import AddNewAddress from "../pages/booking/AddNewAddress";
import MyBookings from "../pages/booking/MyBookings";
import ProtectedRoute from "../middleware/ProtectedRoute";
import StripePayment from "../pages/booking/StripePayment";
import PaymentSuccess from "../pages/booking/PaymentSuccess";
import ChangePassword from "../pages/booking/ChangePassword";
import ChatList from "../pages/booking/ChatList";
import PrivacyPolicy from "../pages/main/PrivacyPolicy";
// Helper function to wrap protected components
const Private = (Component) => (
  <ProtectedRoute>
    <Component />
  </ProtectedRoute>
);

export default function MainRoute() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/service-details/:id" element={<ServiceDetails />} />
      <Route path="/loginModel" element={<LoginModal />} />
      <Route path="/OtpModel" element={<OtpModel />} />
      <Route path="/services" element={<Services />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />

      {/* Protected Routes */}
      <Route path="/Dashboard" element={Private(Dashboard)} />
      <Route path="/mybookings" element={Private(Dashboard)} />
      <Route path="/myprofile" element={Private(Myprofile)} />
      <Route path="/myaddress" element={Private(Myaddress)} />
      <Route path="/mypayment" element={Private(Mypayment)} />
      <Route path="/notification" element={Private(Notifications)} />
      <Route path="/chatlist" element={Private(ChatList)} />
      <Route path="/quotation" element={Private(Quotation)} />
      <Route path="/quotationdetails/:quoteId" element={Private(QuoteDetails)} />
      <Route path="/bookingdetails/:shipmentId" element={Private(BookingDetails)} />
      <Route path="/editprofile" element={Private(EditProfile)} />
      <Route path="/newaddress" element={Private(AddNewAddress)} />
      <Route path="/stripepayment" element={Private(StripePayment)} />
      <Route path="/paymentsuccess" element={Private(PaymentSuccess)} />
      <Route path="/changepassword" element={Private(ChangePassword)} />
    </Routes>
  );
}
